module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "my-5"
  }, [_c('form', [_c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "image/png, image/jpeg"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), (_vm.loadImage) ? _c('div', {
    staticClass: "text-left"
  }, [_vm._m(0)]) : _c('label', {
    staticClass: "button bg-theme-7 text-white button-sm",
    attrs: {
      "for": "file"
    }
  }, [_c('i', {
    staticClass: "fa fa-photo"
  }), _vm._v(" Cambiar Foto\n                ")])])])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Cargando...")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b0d2b63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/user/EditPhoto.vue
// module id = 433
// module chunks = 1